function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2019, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */
function xhrRequest(url, options, callback) {
  var _options;
  options = options || {};
  if (options.env_id) {
    url += "".concat(url.includes("?") ? "&" : "?", "env_id=").concat(options.env_id);
  }
  if (options.toolchainId) {
    url += "".concat(url.includes("?") ? "&" : "?", "toolchainId=").concat(options.toolchainId);
  }

  // request json if dataType is json
  if (options.dataType === "json") {
    if (!options.headers) {
      options.headers = {};
    }
    options.headers.Accept = "application/json";
  }
  var xhr = new XMLHttpRequest();
  xhr.open(options.method || "GET", url);
  if ((_options = options) !== null && _options !== void 0 && _options.headers) {
    Object.keys(options.headers).forEach(function (header) {
      xhr.setRequestHeader(header, options.headers[header]);
    });
  }
  // for security and server-side request handling (e.g. handle auth differently for XHRs)
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  if (options.body) {
    xhr.setRequestHeader("Content-Type", "application/json");
  }
  // propagate the bss account id to ensure that IAM tokens are account-bound
  if (options.bssAccount) {
    xhr.setRequestHeader("X-BSS-Account", options.bssAccount);
  }
  // inject the account context to ensure the correct user || profile token is used
  if (options.accountContext) {
    xhr.setRequestHeader("IBM-Account-Context", options.accountContext);
  }
  xhr.onload = function () {
    var contentType = xhr.getResponseHeader("Content-Type");
    var result = xhr.responseText;
    if (options.dataType === "json" && contentType && contentType.indexOf("application/json") === 0) {
      try {
        result = JSON.parse(result);
      } catch (e) {
        callback(new Error("Error parsing response JSON: ".concat(result)));
      }
    }
    if (xhr.status < 200 || xhr.status >= 300) {
      // tack on the response body message to the error object, either as plain text
      // or as JSON in the form { "description": "..." }
      var error = new Error("Error ".concat(xhr.status));
      var description = _typeof(result) === "object" ? result.description : result;
      var title = _typeof(result) === "object" ? result.title : result;
      if (typeof description === "string") {
        error.description = description;
      }
      if (typeof title === "string") {
        error.title = title;
      }
      callback(error, result, xhr);
      return;
    }
    callback(null, result, xhr);
  };
  xhr.onerror = function (error) {
    callback(error, null, xhr);
  };
  xhr.send(options.body ? JSON.stringify(options.body) : null);
  return xhr;
}
export function xhrPromise(url, options) {
  return new Promise(function (resolve, reject) {
    xhrRequest(url, options, function (error, body, xhr) {
      if (error) {
        error.body = body;
        error.xhr = xhr;
        reject(error);
        return;
      }
      resolve({
        xhr: xhr,
        body: body
      });
    });
  });
}